import { getConnectorTablePreview } from "../../hooks/useConnectorTablePreview";
import { useSemanticModelStore } from "../SemanticModelProvider";

export const loadTablePreview = async (connectorId: string, tableName: string) => {
  const data = await getConnectorTablePreview(connectorId, tableName);
  useSemanticModelStore.setState(
    (state) => {
      state.tableData = data || [];
    },
    false,
    "table/load_preview",
  );
  return data || [];
};
